import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

/** 不可选的最后一刻（含）。按本地钟面比较，可选时间必须严格晚于它。 */
export function utcLowerBound(input: {
  future?: boolean;
  after?: string | null;
  now?: number;
}) {
  const points: Dayjs[] = [];
  if (input.future) points.push(dayjs(input.now ?? Date.now()));
  if (input.after) {
    const at = dayjs(input.after);
    if (at.isValid()) points.push(at);
  }
  if (points.length === 0) return null;
  return points.reduce((max, item) => (item.isAfter(max) ? item : max));
}

export function utcDateDisabled(current: Dayjs, bound: Dayjs) {
  if (current.isBefore(bound, "day")) return true;
  return (
    current.isSame(bound, "day") && bound.hour() === 23 && bound.minute() === 59
  );
}

function until(end: number) {
  return Array.from({ length: Math.max(0, end) }, (_, i) => i);
}

export function utcTimeDisabled(current: Dayjs | null | undefined, bound: Dayjs) {
  if (!current || !current.isSame(bound, "day")) return {};
  const hour = bound.hour();
  const minute = bound.minute();
  return {
    disabledHours: () => until(minute >= 59 ? hour + 1 : hour),
    disabledMinutes: (selectedHour: number) =>
      selectedHour === hour ? until(minute + 1) : [],
  };
}
